import { IQuickLinkItem } from '@/ui';
import { INTERNAL_LINK_TYPE_ID } from '@move-frontend/contentful';
import { Section, SectionHeader } from './Section';
import {
	ASSET_LINK_TYPE_ID,
	EMAIL_LINK_TYPE_ID,
	EXTERNAL_LINK_TYPE_ID,
	PHONE_LINK_TYPE_ID,
} from '../../../../contentful/constants';
import { IQuickLinksSectionEntry } from '../../../../contentful/types/IQuickLinksSectionEntry';
import { QuickLink } from '../../../../components/common/quick-links/QuickLink';
import { getLinkItemsForEntries } from '../../domain/use-cases/getLinkItemsForEntries';
import { useCommonData } from '../../../../common-data/useCommonData';
import { QuickLinksGrid } from '../../../../components/common/quick-links/QuickLinksGrid';

export interface IQuickLinksSectionProps {
	section: IQuickLinksSectionEntry;
}

export function QuickLinksSection({ section }: IQuickLinksSectionProps) {
	const { pathToPageIdMap } = useCommonData();
	const items =
		section.fields.links &&
		getLinkItemsForEntries<IQuickLinkItem>(
			section.fields.links,
			pathToPageIdMap,
		);

	return (
		<Section>
			{section.fields.title && (
				<SectionHeader>{section.fields.title}</SectionHeader>
			)}
			<QuickLinksGrid>
				{items?.map((linkItem: IQuickLinkItem) => {
					switch (linkItem.type) {
						case INTERNAL_LINK_TYPE_ID:
							return (
								<QuickLink
									key={linkItem.key}
									type="internal"
									label={linkItem.title}
									url={linkItem.url}
								/>
							);
						case EXTERNAL_LINK_TYPE_ID:
							return (
								<QuickLink
									key={linkItem.key}
									type="external"
									label={linkItem.title}
									url={linkItem.url}
								/>
							);
						case ASSET_LINK_TYPE_ID:
							return (
								<QuickLink
									key={linkItem.key}
									type="asset"
									label={linkItem.title}
									url={linkItem.url}
								/>
							);
						case EMAIL_LINK_TYPE_ID:
							return (
								<QuickLink
									key={linkItem.key}
									type="email"
									label={linkItem.title}
									url={`mailto:${linkItem.address}`}
								/>
							);
						case PHONE_LINK_TYPE_ID:
							return (
								<QuickLink
									key={linkItem.key}
									type="phone"
									label={linkItem.title}
									url={`tel:${linkItem.title}`}
								/>
							);
						default:
							return null;
					}
				})}
			</QuickLinksGrid>
		</Section>
	);
}
